import { animate } from 'animejs';
import { mobile } from '../utils/globalVar';

class Module07SliderCards {
    constructor() {
        const AUTOPLAY_DELAY = 5000;
        const ANIMATION_DURATION = 800;
        
        let autoplayIntervals = new Map();
        let isFirstLoad = true;
        
        const cache = {
            sliderModules: null
        };
        
        const initFunc = () => {
            initCache();
            setupSliders();
        };

        const initCache = () => {
            cache.sliderModules = document.querySelectorAll(".module-07-slider-cards");
            
            if (!cache.sliderModules.length) return;
        };
        
        const isMobile = () => {
            return mobile.matches;
        };
        
        const setupSliders = () => {
            cache.sliderModules.forEach(module => {
                const slides = module.querySelectorAll(".slide-item");
                const wrapper = module.querySelector(".slider-wrapper");

                if (slides.length <= 1) {
                    if (slides.length === 1) {
                        const slide = slides[0];
                        slide.style.position = 'relative';
                        slide.classList.add('active');
                        slide.style.transform = 'translateX(0)';
                        slide.style.opacity = '1';
                    }
                    return;
                }
                
                slides.forEach((slide, index) => {
                    slide.style.position = 'absolute';
                    slide.style.left = '0';
                    slide.style.right = '0';
                    slide.style.width = '100%';
                    
                    slide.style.zIndex = slides.length - index;
                    
                    if (index === 0) {
                        slide.classList.add('active');
                        slide.style.transform = 'translateX(0)';
                        slide.style.opacity = '1';
                    } else {
                        slide.style.transform = 'translateX(100%)';
                        slide.style.opacity = '0';
                    }
                });

                initEvents(module);
                
                if (!isMobile()) {
                    startAutoplay(module);
                }
                
                const firstSlide = slides[0];
                if (firstSlide) {
                    wrapper.style.height = `${firstSlide.offsetHeight}px`;
                }
                
                const steps = module.querySelectorAll(".step");
                if (steps.length) {
                    steps[0].classList.add('active');
                }
                
                window.addEventListener('resize', () => {
                    updateSliderHeight(module);
                    
                    if (isMobile()) {
                        pauseAutoplay(module);
                    } else if (!autoplayIntervals.has(module)) {
                        startAutoplayForModule(module);
                    }
                });
            });
            
            if (isFirstLoad) {
                setTimeout(() => {
                    isFirstLoad = false;
                }, 300);
            }
        };
        
        const updateSliderHeight = (module) => {
            const wrapper = module.querySelector('.slider-wrapper');
            const activeSlide = module.querySelector('.slide-item.active');
            
            if (activeSlide && wrapper) {
                setTimeout(() => {
                    wrapper.style.height = `${activeSlide.offsetHeight}px`;
                }, 50);
            }
        };
        
        const getCurrentIndex = (module) => {
            const activeStep = module.querySelector(".step.active");
            const steps = Array.from(module.querySelectorAll(".step"));
            return steps.indexOf(activeStep);
        };
        
        const goToSlide = (module, targetIndex, isInitial = false, forceDirection = null) => {
            const slides = module.querySelectorAll(".slide-item");
            const steps = module.querySelectorAll(".step");
            const currentIndex = getCurrentIndex(module);
            const totalSlides = slides.length;
            
            if (currentIndex === targetIndex && !isInitial) return;
            
            steps.forEach((step, i) => {
                step.classList.toggle("active", i === targetIndex);
            });
            
            const currentSlide = slides[currentIndex];
            const targetSlide = slides[targetIndex];
            
            let direction;
            
            if (forceDirection !== null) {
                direction = forceDirection;
            } else {
                if (currentIndex === totalSlides - 1 && targetIndex === 0) {
                    direction = 1;
                } 
                else if (currentIndex === 0 && targetIndex === totalSlides - 1) {
                    direction = -1;
                } 
                else {
                    direction = targetIndex > currentIndex ? 1 : -1;
                }
            }
            
            const exitDirection = direction > 0 ? -100 : 100;
            const enterDirection = direction > 0 ? 100 : -100;
            
            if (currentSlide && !isInitial) {
                targetSlide.style.transform = `translateX(${enterDirection}%)`;
                targetSlide.style.opacity = '0';
                targetSlide.style.zIndex = parseInt(currentSlide.style.zIndex) + 1;
                
                animate(currentSlide, {
                    translateX: [0, `${exitDirection}%`],
                    opacity: [1, 0],
                    ease: 'inOutQuad',
                    duration: ANIMATION_DURATION,
                    complete: () => {
                        currentSlide.classList.remove('active');
                        if (!currentSlide.classList.contains('active')) {
                            currentSlide.style.transform = `translateX(${exitDirection}%)`;
                            currentSlide.style.opacity = '0';
                        }
                    }
                });
            }
            
            // Animer l'entrée du nouveau slide
            animate(targetSlide, {
                translateX: [`${enterDirection}%`, 0],
                opacity: [0, 1],
                ease: 'outQuad',
                duration: ANIMATION_DURATION,
                delay: isInitial ? 0 : 100,
                begin: () => {
                    targetSlide.classList.add('active');
                },
                complete: () => {
                    updateSliderHeight(module);
                }
            });
        };
        
        const initEvents = () => {
            cache.sliderModules.forEach(module => {
                const steps = module.querySelectorAll(".step");
                const sliderWrapper = module.querySelector(".slider-wrapper");
                
                steps.forEach((step, index) => {
                    step.addEventListener("click", () => {
                        if (!isMobile()) {
                            pauseAutoplay(module);
                        }
                        
                        goToSlide(module, index);
                        
                        if (!isMobile()) {
                            setTimeout(() => {
                                startAutoplayForModule(module);
                            }, AUTOPLAY_DELAY);
                        }
                    });
                });
                
                setupTouchNavigation(module, sliderWrapper);
            });
            
            document.addEventListener("visibilitychange", () => {
                // Ne gérer l'autoplay que si on n'est pas sur mobile
                if (!isMobile()) {
                    if (document.hidden) {
                        cache.sliderModules.forEach(module => {
                            pauseAutoplay(module);
                        });
                    } else {
                        cache.sliderModules.forEach(module => {
                            startAutoplayForModule(module);
                        });
                    }
                }
            });
        };
        
        const setupTouchNavigation = (module, sliderWrapper) => {
            let touchStartX = 0;
            let touchEndX = 0;
            let isDragging = false;
            
            const handleTouchStart = (e) => {
                touchStartX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
                isDragging = true;
                
                if (!isMobile()) {
                    pauseAutoplay(module);
                }
            };
            
            const handleTouchMove = (e) => {
                if (!isDragging) return;
                e.preventDefault();
            };
            
            const handleTouchEnd = (e) => {
                if (!isDragging) return;
                isDragging = false;
                
                touchEndX = e.type.includes('mouse') ? e.clientX : e.changedTouches[0].clientX;
                const diffX = touchStartX - touchEndX;
                const threshold = 50;
                
                if (Math.abs(diffX) > threshold) {
                    const currentIndex = getCurrentIndex(module);
                    const steps = module.querySelectorAll(".step");
                    let targetIndex = currentIndex;
                    const totalSteps = steps.length;
                    
                    if (diffX > 0) {
                        targetIndex = (currentIndex + 1) % totalSteps;
                        goToSlide(module, targetIndex, false, 1);
                    } else {
                        targetIndex = (currentIndex - 1 + totalSteps) % totalSteps;
                        goToSlide(module, targetIndex, false, -1); 
                    }
                }
                
                if (!isMobile()) {
                    setTimeout(() => {
                        startAutoplayForModule(module);
                    }, AUTOPLAY_DELAY);
                }
            };
            
            // Événements tactiles
            sliderWrapper.addEventListener("touchstart", handleTouchStart, { passive: true });
            sliderWrapper.addEventListener("touchmove", handleTouchMove, { passive: false });
            sliderWrapper.addEventListener("touchend", handleTouchEnd);
            
            // Événements souris
            sliderWrapper.addEventListener("mousedown", handleTouchStart);
            sliderWrapper.addEventListener("mousemove", handleTouchMove);
            sliderWrapper.addEventListener("mouseup", handleTouchEnd);
            sliderWrapper.addEventListener("mouseleave", handleTouchEnd);
        };
        
        const startAutoplay = () => {
            if (!isMobile()) {
                cache.sliderModules.forEach(module => {
                    startAutoplayForModule(module);
                });
            }
        };
        
        const startAutoplayForModule = (module) => {
            if (isMobile()) return;
            
            pauseAutoplay(module);
            
            const interval = setInterval(() => {
                const currentIndex = getCurrentIndex(module);
                const steps = module.querySelectorAll(".step");
                const nextIndex = (currentIndex + 1) % steps.length;
                
                goToSlide(module, nextIndex, false, 1);
            }, AUTOPLAY_DELAY);
            
            autoplayIntervals.set(module, interval);
        };
        
        const pauseAutoplay = (module) => {
            if (autoplayIntervals.has(module)) {
                clearInterval(autoplayIntervals.get(module));
                autoplayIntervals.delete(module);
            }
        };
        
        initFunc();
    }
}

export { Module07SliderCards };
